import {Injectable, OnInit} from '@angular/core';
import {Payee} from '../models/payee.model';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../base.service';
import {Currency} from "../../models/latipay/currency.model";

@Injectable()
export class AssessmentQuestionService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('assessment-question', http);
    }

    ngOnInit(): void {
    }
}